export { Adapter } from "./adapter.decorator";
